// Collections in the DB
const FIREBASE_COLLECTIONS = {
    /** Collections  */
    ADMINS:                 'Admins',
    AI:                     'AI',
    CALLS:                  'Calls',
    CALLS_FORWARDING:       'CallsForwarding',
    COMPANIES:              'Companies',
    USERS:                  'Users',
    CONTACTS:               'Contacts',
    CONTACTS_QUEUE:         'ContactsQueue',
    SUBSCRIPTIONS:          'Subscriptions',
    SMS:                    'SMS',
    SMS_CONVERSATIONS:      'SmsConversations',
    PLANS:                  'Plans',
    JOBS:                   'Jobs',
    NUMBERS:                'Numbers',
    NOTIFICATIONS:          'Notifications',
    FEEDBACKS:              'Feedbacks',
    DOMAINS:                'Domains',
    SCENARIOS:              'Scenarios',
    TASKS:                  'Tasks',
    AI_CHATS:               'AiChats',
    LOGS:                   'Logs',
    VOICEMAILS:             'Voicemails',
    TAGS:                   'Tags',
    COSTS:                  'Costs',
    OAUTH:                  'OAuth',

    /** Subcollections */
    // Numbers subcollections
    NUMBERS_HISTORY:        'history',
    // Users subcollections
    USERS_HISTORY:          'history',
    USERS_FILES:            'files',
    // Companies subcollections
    COMPANIES_FILES:        'files',
    // Plans and Subscriptions subcollections
    PLANS_LEEDBUCKS_RATES_HISTORY:          'leedbucks_rates_history',
    SUBSCRIPTIONS_LEEDBUCKS_RATES_HISTORY:  'leedbucks_rates_history',
    SUBSCRIPTIONS_LEEDBUCKS_CREDITS_HISTORY: 'leedbucks_credits_history',
    
    // CRM Integration collections
    IMPORT_CHECKPOINTS:     'ImportCheckpoints',
    CRM_SYNC_QUEUE:         'CrmSyncQueue'
};

// Export the array
export default FIREBASE_COLLECTIONS;
